import { countries, usaStates } from "~/util"

const LOCATIONS = {
	boroPark: "Boro Park",
	crownHeights: "Crown Heights",
	fiveTowns: "Five Towns",
	monsey: "Monsey",
	online: "Online",
	lakewood: "Lakewood",
	passaic: "Passaic",
	lodi: "Lodi, NJ",
};

const SEMESTERS = {
//keep them in order that it will show up online.

	//summer26: {name: "Summer 2026", label: "Summer 2026 (Begins May, 2026)"},

	spring27: {name: "Spring 2027", label: "Spring 2027 (Begins January, 2027)"},
	summer27: {name: "Summer 2027", label: "Summer 2027 (Begins May, 2027"},
	fall27: {name: "Fall 2027", label: "Fall 2027 (Begins September, 2027)"},




}

const PROGRAMS = {
	underGraduate: {
		name: 'underGraduate',
		title: 'Choosing your Undergraduate Degree Program',
		description: '- To apply to any undergraduate program, you must be a high school graduate.',
		headers: ['Degree', 'Semesters', 'Degree-Conferring College',],
	},
	graduate: {
		name: 'graduate',
		title: 'Choosing your Graduate Degree Program',
		description: 'To apply to any graduate program, you must have a bachelor’s degree from an accredited university or college approved by Sara Schenirer.',
		headers: ['Degree', 'Semesters', 'Degree-Conferring College',],
	},
	postGraduate: {
		name: 'postGraduate',
		title: 'Choosing your Post-Graduate Degree Program',
		description: 'To apply for the Manhattanville College Advanced Certificate in ABA (LBA & BCBA), you must have a graduate degree in the field of education or psychology from an accredited university or college approved by Sara Schenirer.',
		headers: ['Degree', 'Semesters', 'Degree-Conferring College',],
	},
	preRequisite: {
		name: 'preRequisite',
		title: 'Choosing your Prerequisite Degree Program',
		description: 'To apply to any prerequisite program, you must have obtained/be currently enrolled in a bachelor’s degree from an accredited university or college approved by Sara Schenirer.',
		// headers: ['Prerequisite Option', '# of Courses', 'Degree-Conferring College',],
		headers: ['', '', '',],
	},
}

export default {
	countries: countries,
	usaStates: usaStates,
	programs: PROGRAMS,
	semesters: {
		Female: [

			SEMESTERS.spring27,
			SEMESTERS.fall27,
		],
		Male: [





			SEMESTERS.spring27,
			SEMESTERS.summer27,
			SEMESTERS.fall27,

		]
	},
	fieldsOfInterest: {
		Female: [
			{
				name: 'BA in Psychology',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology',
				showHSSection: true,
				showBachelorSection: true,
				showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

						{
						semester: SEMESTERS.spring27.name,
						locations: LOCATIONS,
						},
					{
						semester: SEMESTERS.fall27.name,
						locations: LOCATIONS,
					},
				],
				popup: ["BA in Psychology (Avail Fall & Spring)", "3", "University of Mt St Vincent<br/>Saint Peter’s University",]
			},
			{
				name: 'BA in Psychology - ABA Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - ABA Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: LOCATIONS,
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: LOCATIONS,
					},
				],
				popup: ["BA in Psychology - ABA Track (Avail Fall & Spring)", "3", "University of Mt St Vincent<br>Saint Peter’s University",],
			},{
				name: 'BA in Psychology - Business Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Business Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.lakewood, LOCATIONS.passaic,LOCATIONS.online,],

					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.lakewood, LOCATIONS.passaic,LOCATIONS.online,],
					},
				],
				popup: ["BA in Psychology - Business Track (Avail Fall & Spring)", "3", "Saint Peter’s University",],
			},
			{
				name: 'BA in Psychology - Educ Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Educ Track',
				showHSSection: true, showBachelorSection: true,
				showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey,LOCATIONS.online,],
					// },
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey,LOCATIONS.online,],
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey,LOCATIONS.online,],
					},
				],
				popup: ["BA in Psychology - Educ Track (Avail Fall & Spring)", "3", "University of Mt St Vincent",],
			},
			{
				name: 'BA in Psychology - Nursing Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Nursing Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey, LOCATIONS.online, LOCATIONS.lakewood]

					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey, LOCATIONS.online, LOCATIONS.lakewood, LOCATIONS.passaic]
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey, LOCATIONS.online]
					// },
				],
				popup: ["BA in Psychology - Nursing Track (Avail Fall & Spring)", "3", "University of Mt St Vincent<br>Saint Peter’s University",],
			},
			{
				name: 'BA in Psychology - Nutrition Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Nutrition Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: LOCATIONS,
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: LOCATIONS,
					// },
					{
						semester: SEMESTERS.fall27.name,
						locations: LOCATIONS,
					},
				],
				popup: ["BA in Psychology - Nutrition Track (Avail Fall & Spring)", "4", "University of Mt St Vincent<br>Saint Peter’s University",],
			},

			{

				name: 'BA in Psychology - Occupational Therapy Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Occupational Therapy Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: LOCATIONS,
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: LOCATIONS,
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: LOCATIONS,
					// },
				],
				popup: ["BA in Psychology - Occupational Therapy Track (Avail Fall & Spring)", "3", "University of Mt St Vincent<br>Saint Peter’s University",],
			},


			{
				name: 'BA in Psychology - Pre-Med Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Pre-Med Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey, LOCATIONS.online]

					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.boroPark,LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey, LOCATIONS.online]
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey, LOCATIONS.online]
					// },
				],
				popup: ["BA in Psychology - Pre-Med Track (Avail Fall & Spring)", "4", "University of Mt St Vincent",],
			},
			{
				name: 'BA in Psychology - Sonography Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Sonography Track',
				showHSSection: true, showBachelorSection: true,
				showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey,LOCATIONS.online,],
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns, LOCATIONS.monsey,LOCATIONS.online,],
					},
				],
				popup: ["BA in Psychology - Sonography Track (Avail Fall & Spring)", "9", "University of Mt St Vincent/CAHE",],
			},
			{
				name: 'BA in Psychology-Social Work Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology-Social Work Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: LOCATIONS,
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: LOCATIONS,
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: LOCATIONS,
					// },
				],
				popup: ["BA in Psychology-Social Work Track (Avail Fall & Spring)", "3", "University of Mt St Vincent<br>Saint Peter’s University",],
			},


			{
				name: 'BA in Psychology-Speech Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology-Speech Track',
				showHSSection: true, showBachelorSection: true,
				showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: LOCATIONS,
					// },

					{
						semester: SEMESTERS.fall27.name,
						locations: LOCATIONS,
					},
					{
					semester: SEMESTERS.spring27.name,
					locations: LOCATIONS,
					},
				],
				popup: ["BA in Psychology-Speech Track (Avail Fall & Spring)", "3", "University of Mt St Vincent<br/>Saint Peter’s University",],
			},


			{
				name: 'BA in Psychology - IMPACT Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - IMPACT Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,

				courses: [
					// {
					// 	semester: SEMESTERS.fall22.name,
					// 	locations: LOCATIONS,
					// },

				],
				popup: [],
			},



			{
				name: 'BS in Accounting',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor in Accounting',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [ LOCATIONS.online],
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [ LOCATIONS.online],
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [ LOCATIONS.online],
					// },
				],
				popup: ["Bachelor in Accounting (Avail Fall & Spring)", "5", "University of Mt St Vincent",],
			},
			{
				name: 'BA in Business Administration',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor in Business Administration',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.online],
					// },
				],
				popup: ["Bachelor in Business Administration (Avail Fall & Spring) / Female", "3", "University of Mt St Vincent",],
			},

			{
				name: 'Bachelor of Science in Data Science',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor of Science in Data Science & AI',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

//					{
//						semester: SEMESTERS.spring26.name,
//						locations: [LOCATIONS.online],
//					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.online],
					// },
				],
				popup: ["Bachelor of Science in Data Science & Artificial Intelligence (Avail Fall)", "3", "Saint Peter’s University",],
			},
			{
				name: 'Bachelor of Science in Legal Studies',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor of Science in Legal Studies',
				showHSSection: true,
				showBachelorSection: true,
				showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations:[ LOCATIONS.online],
					// },
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["Bachelor of Science in Legal Studies (Avail Fall & Spring)", "4", "Crestpoint University",]
			},/*
			{
				name: 'BA in Education and Special Education',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Education and Special Education',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					// {
					// 	semester: SEMESTERS.spring26.name,
					// 	locations: [LOCATIONS.lakewood, LOCATIONS.passaic],
					// },
					// {
					// 	semester: SEMESTERS.fall26.name,
					// 	locations: [LOCATIONS.online],
					// },
					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.lakewood, LOCATIONS.passaic],
					// },
				],
				popup: ["BA in Education and Special Education (Avail Fall)<br><i>This is for students located in <strong>New Jersey</strong>.</i>", "5", "Saint Peter’s University",],
			},*/
			{
				name: 'Doctorate in Counseling Psychology',
				program: PROGRAMS.graduate.name,
				label: 'Doctorate in Counseling Psychology',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": true,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": true,
				"showEssaySection": true,
				"showClinicalEssaySection": false,

				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.lodi],
					},
				],
				popup: ["Doctorate in Counseling Psychology (Avail Fall)", "12", "Felician University",],
			},

			{
				name: 'MS in Education and Special Education',
				program: PROGRAMS.graduate.name,
				label: 'MS in Education and Special Education',
				showHSSection: true, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns,  LOCATIONS.online],
					},
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.boroPark, LOCATIONS.crownHeights, LOCATIONS.fiveTowns,  LOCATIONS.online],
					},
				],
				popup: ["M.S. ED in Education & Special Education (Avail Fall & Spring)", "4", "University of Mt St Vincent",],
			},
			{
				name: 'MBA',
				program: PROGRAMS.graduate.name,
				label: 'MBA',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [

					 // {
						// semester: SEMESTERS.fall24.name,
					 // 	locations: [LOCATIONS.online],
					 // },
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["MBA (Avail Fall)", "4", "Saint Peter’s University",],
			},
			{
				name: 'MSW in Social Work',
				program: PROGRAMS.graduate.name,
				label: 'MSW in Social Work ',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
					/*
				{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},*/
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},

				],
				popup: ["MSW in Social Work (Avail Fall & Spring)", "4", "Wurzweiler",],
			},
			{
				name: 'MPS in Applied Behavior Analysis (ABA) – LBA & BCBA',
				program: PROGRAMS.graduate.name,
				label: 'MPS in Applied Behavior Analysis (ABA) – LBA & BCBA',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [

					 {
					 	semester: SEMESTERS.spring27.name,
					 	locations: [LOCATIONS.online],
					 },
					 // {
					 // 	semester: SEMESTERS.fall24.name,
					 // 	locations: [LOCATIONS.online],
					 // },
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["M.P.S. in ABA (LBA/BCBA) (Avail Fall & Spring)", "5", "Manhattanville College",],
			},
		{
				name: 'MS in Nutrition',
				program: PROGRAMS.graduate.name,
				label: 'MS in Nutrition',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
					/* {
					 	semester: SEMESTERS.spring27.name,
					 	locations: [LOCATIONS.online],
				 },*/
				],
				popup: ["M.S. in Nutrition and Nutrigenomics (Avail Spring)", "5", "Manchester University",],
			},
			{
				name: 'Master of Speech-Language Pathology',
				program: PROGRAMS.graduate.name,
				label: 'Master of Speech and Language Pathology',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
					// {
					// 	semester: SEMESTERS.spring26.name,
					// 	locations: [LOCATIONS.online],
					// },
					/* {
						semester: SEMESTERS.fall26.name,
						locations: [LOCATIONS.online],
					}*/
				],
				 popup: ["Master of Speech and Language Pathology (Avail Fall)", "5", "Katz School of Health",],

			},
			{
				name: 'Occupational Therapy Doctorate (OTD)',
				program: PROGRAMS.graduate.name,
				label: 'Occupational Therapy Doctorate (OTD)',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
				/*{


					semester: SEMESTERS.spring27.name,
					locations: ["Hybrid - Bronx/Online"],

					},*/
				],
				popup: ["Occupational Therapy Doctorate (OTD) (Avail Spring)", "8", "Katz School of Health",],
			},

			{
				name: 'Advance Certificate in Applied Behavior Analysis (ABA) – LBA & BCBA',
				program: PROGRAMS.postGraduate.name,
				label: 'Advance Certificate in Applied Behavior Analysis (ABA) – LBA & BCBA',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": true,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["Advance Certificate in ABA (LBA/BCBA) (Avail Fall & Spring)", "4", "Manhattanville College",],

			},


			{
				name: 'Medical Prereq Courses',
				program: PROGRAMS.preRequisite.name,
				label: 'Medical Prereq Courses',
				showHSSection: true, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
					popup: ["Medical ", "5", "University of Mt St Vincent",],
			},
			{
            				name: 'Nutrition Prereq Courses',
            				program: PROGRAMS.preRequisite.name,
            				label: 'Nutrition Prereq Courses',
            				showHSSection: true, showBachelorSection: true, showMasterSection: true,
            				"showReferencesSection": false,
            				"showUnofficialGraduateTranscriptsSection": false,
            				"showUnofficialUGTranscriptsSection": true,
            				"showUnofficialHSTranscriptsSection": true,
            				"showGRESection": false,
            				"showRecommendationLettersSection": false,
            				"showResumeSection": false,
            				"showEssaySection": false,
            				"showPersonalStatementSection": false,
            				courses: [
								{
            						semester: SEMESTERS.spring27.name,
            						locations: [LOCATIONS.online],
            					},

								{
									semester: SEMESTERS.fall27.name,
									locations: [LOCATIONS.online],
								},
            				],
            				popup: ["Nutrition ", "5", "University of Mt St Vincent",],
            			},
            			{

					name: 'OT Prereq Courses',
					program: PROGRAMS.preRequisite.name,
					label: 'OT Prereq Courses',
					showHSSection: true, showBachelorSection: true, showMasterSection: true,
					"showReferencesSection": false,
					"showUnofficialGraduateTranscriptsSection": false,
					"showUnofficialUGTranscriptsSection": true,
					"showUnofficialHSTranscriptsSection": true,
					"showGRESection": false,
					"showRecommendationLettersSection": false,
					"showResumeSection": true,
					"showEssaySection": false,
					"showPersonalStatementSection": false,
					courses: [
						{
							semester: SEMESTERS.spring27.name,
							locations: [LOCATIONS.online],
						},

						{
							semester: SEMESTERS.fall27.name,
							locations: [LOCATIONS.online],
						},


                        				],
                        				popup: ["OT ", "5", "University of Mt St Vincent",],
                        			},
			{
				name: 'Speech (SLP) Prereq Courses',
				program: PROGRAMS.preRequisite.name,
				label: 'Speech (SLP) Prereq Courses',
				showHSSection: true, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": false,
				courses: [
				{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["SLP ", "5", "University of Mt St Vincent",],
			},


		],
		Male: [
			{
				name: 'BA in Business Administration',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor in Business Administration',
				showHSSection: true, showBachelorSection: true,  showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					// {
					// 	semester: SEMESTERS.fall24.name,
					// 	locations: [LOCATIONS.online],
					// },
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["Bachelor in Business Administration (Avail Fall & Spring) / Male", "3", "Saint Peter’s University/University of Mt St Vincent",],
			},

			{
				name: 'BA in Psychology',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology',
				showHSSection: true, showBachelorSection: true,   showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

				{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},


					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["BA in Psychology (Avail Fall & Spring)", "3", "Saint Peter’s University/University of Mt St Vincent",],
			},
			{
				name: 'BA in Psychology - Nursing Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Nursing Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [ LOCATIONS.online]

					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [ LOCATIONS.online]
					},

				],
				popup: ["BA in Psychology - Nursing Track (Avail Fall & Spring)", "3", "University of Mt St Vincent",],
			},
			{
				name: 'BA in Psychology - Pre-Med Track',
				program: PROGRAMS.underGraduate.name,
				label: 'BA in Psychology - Pre-Med Track',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [ LOCATIONS.online]

					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [ LOCATIONS.online]
					},

				],
				popup: ["BA in Psychology - Pre-Med Track (Avail Fall & Spring)", "4", "University of Mt St Vincent",],
			},
			{
				name: 'Bachelor of Science in Legal Studies',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor of Science in Legal Studies',
				showHSSection: true, showBachelorSection: true,   showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},


					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["Bachelor of Science in Legal Studies (Avail Fall & Spring)", "4", "Crestpoint University",],
			},
			{
				name: 'BS in Accounting',
				program: PROGRAMS.underGraduate.name,
				label: 'Bachelor in Accounting',
				showHSSection: true, showBachelorSection: true, showMasterSection: false,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": false,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": true,
				courses: [

					{
						semester: SEMESTERS.spring27.name,
						locations: [ LOCATIONS.online],
					},
					{
						semester: SEMESTERS.fall27.name,
						locations: [ LOCATIONS.online],
					},

				],
				popup: ["Bachelor in Accounting (Avail Fall & Spring)", "5", "University of Mt St Vincent",],
			},
			{
				name: 'Doctorate in Counseling Psychology',
				program: PROGRAMS.graduate.name,
				label: 'Doctorate in Counseling Psychology',
				showHSSection: false, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": true,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": true,
				"showEssaySection": true,
				"showClinicalEssaySection": false,
				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.lodi],
					},
				],
				popup: ["Doctorate in Counseling Psychology (Avail Fall)", "12", "Felician University",],
			},
			{
				name: 'MS in Accounting',
				program: PROGRAMS.graduate.name,
				label: 'MS in Accounting',
				showHSSection: false	, showBachelorSection: true,   showMasterSection: true,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["MS in Accounting (Avail Fall & Spring)", "4", "Saint Peter’s University",],
			},
			{
				name: 'MS in Education and Special Education',
				program: PROGRAMS.graduate.name,
				label: 'MS in Education and Special Education',
				showHSSection: true, showBachelorSection: true,   showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["M.S. ED in Education & Special Education (Avail Fall & Spring) / Male", "5", "University of Mt St Vincent",],
			},
			{
				name: 'MSW in Social Work',
				program: PROGRAMS.graduate.name,
				label: 'MSW in Social Work',
				showHSSection: false, showBachelorSection: true,   showMasterSection: true,
				"showReferencesSection": true,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [
/*
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},*/
					{
						semester: SEMESTERS.summer27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["MSW in Social Work (Avail Spring & Summer)", "5", "Wurzweiler",],
			},
			{
				name: 'MPS in Applied Behavior Analysis (ABA) – LBA & BCBA',
				program: PROGRAMS.graduate.name,
				label: 'MPS in Applied Behavior Analysis (ABA) – LBA & BCBA',
				showHSSection: false, showBachelorSection: true,   showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["MPS in Applied Behavior Analysis (ABA) - LBA & BCBA (Avail Fall)", "5", "Manhattanville College",],
			},
			{
				name: 'MBA',
				program: PROGRAMS.graduate.name,
				label: 'MBA',
				showHSSection: false, showBachelorSection: true,   showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [


					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["MBA - (Avail Fall)", "5", "Saint Peter’s University",],
			},
		/*	{
				name: 'Master in Cyber Security',
				program: PROGRAMS.graduate.name,
				label: 'Master in Cyber Security',
				showHSSection: false, showBachelorSection: true,  showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": false,
				"showGRESection": false,
				"showRecommendationLettersSection": true,
				"showResumeSection": true,
				"showEssaySection": true,
				"showPersonalStatementSection": false,
				courses: [

					{
						semester: SEMESTERS.fall25.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["Master in Cyber Security (Avail Fall)", "5", "Katz School",],
			},*/

			 {
				name: 'Advance Certificate in Applied Behavior Analysis (ABA) – LBA & BCBA',
			 	program: PROGRAMS.postGraduate.name,
			 	label: 'Advance Certificate in Applied Behavior Analysis (ABA) – LBA & BCBA',
			 	showHSSection: false, showBachelorSection: true, showMasterSection: true,
			 	"showReferencesSection": false,
			 	"showUnofficialGraduateTranscriptsSection": true,
			 	"showUnofficialUGTranscriptsSection": false,
			 	"showUnofficialHSTranscriptsSection": false,
			 	"showGRESection": false,
			 	"showRecommendationLettersSection": true,
			 	"showResumeSection": true,
			 	"showEssaySection": true,
			 	"showPersonalStatementSection": false,
			 	courses: [

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
			 	],

				 popup: ["Advance Certificate in ABA (LBA/BCBA) (Avail Fall)", "4", "Manhattanville College",],
			 },
			{
				name: 'Medical Prereq Courses',
				program: PROGRAMS.preRequisite.name,
				label: 'Medical Prereq Courses',
				showHSSection: true, showBachelorSection: true, showMasterSection: true,
				"showReferencesSection": false,
				"showUnofficialGraduateTranscriptsSection": false,
				"showUnofficialUGTranscriptsSection": true,
				"showUnofficialHSTranscriptsSection": true,
				"showGRESection": false,
				"showRecommendationLettersSection": false,
				"showResumeSection": false,
				"showEssaySection": false,
				"showPersonalStatementSection": false,
				courses: [
					{
						semester: SEMESTERS.spring27.name,
						locations: [LOCATIONS.online],
					},

					{
						semester: SEMESTERS.fall27.name,
						locations: [LOCATIONS.online],
					},
				],
				popup: ["5 Prereqs - Medical (Bachelor's Degree Required; otherwise select BA Psych or BA Psych Medical Track)", "5", "University of Mt St Vincent",],
			},


		],
	},
}



// WEBPACK FOOTER //
// ./resources/js/util/form-dependencies.js